<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Ente di Formazione Professionale accreditato dalla Regione Campania, fondato nel 1957. Da oltre 50 anni siamo impegnati per la formazione dei giovani di Caserta finalizzato all’educazione e alla preparazione degli stessi per l’inserimento nel mondo del lavoro.
                    </p>
                    <ul class="social-link d-none">
                        <li><a href="https://www.facebook.com/newformacademy/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/new_form_academy/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.ascen.academy/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.ascen.academy/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Piazza Aldo Moro 23/24<br>81100 Caserta - Italia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390823322095">Telefono: (+39) 0823-322095</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@ascen.it">info@ascen.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390823322095">Lunedì-Venerdì: 09:00÷18:00<br>Sabato: 09:00÷13:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2023 Ascen - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2">
                    <ul>
                        <li><a target="_blank" href="https://www.ascen.it/privacy-policy/">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
